import { render, staticRenderFns } from "./user_questions_list.vue?vue&type=template&id=ddfd1b9a&scoped=true"
import script from "./user_questions_list.vue?vue&type=script&lang=js"
export * from "./user_questions_list.vue?vue&type=script&lang=js"
import style0 from "./user_questions_list.vue?vue&type=style&index=0&id=ddfd1b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd1b9a",
  null
  
)

export default component.exports